export const ONE_MINUTE = 1000 * 60;

export const FIFTEEN_MINUTES = ONE_MINUTE * 15;

export const THIRTY_MINUTES = ONE_MINUTE * 30;

export const ONE_HOUR = ONE_MINUTE * 60;

export const TWENTY_FOUR_HOURS = ONE_HOUR * 24;
